module.exports = __webpack_public_path__ + "static/media/princess-min.34218e29.png";